import React, { FC } from 'react';
import { BoxProps } from 'enova-frontend-components';

import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { useUser } from '../../../hooks/useUser';
import { AppRoute, hasPermission, MainScreenTab } from '../../../utils/navigation';
import { SideMenu } from '../../building/menu/styledComponents';

import { SideMenuButton } from './sideMenuButton';
import { DropDownMenu } from './dropDownMenu';
import { DropDownMenuItem } from './dropDownMenuItem';

export const MainMenu: FC<BoxProps> = () => {
  const { xsScreen } = useMediaQuery();
  const { user } = useUser();
  const isExpertUser = hasPermission(AppRoute.EXPERT_REGISTRATION, user);

  // Dropdown menu for small screens
  if (xsScreen) {
    return (
      <DropDownMenu>
        <DropDownMenuItem tab={MainScreenTab.BUILDINGS} />
        <DropDownMenuItem tab={MainScreenTab.OTHERS_BUILDINGS} />
        <DropDownMenuItem tab={MainScreenTab.SEARCH} />

        {isExpertUser && <DropDownMenuItem tab={MainScreenTab.EXPERT_REGISTRATION} />}
      </DropDownMenu>
    );
  }

  // Tab menu for larger screens
  return (
    <SideMenu>
      <SideMenuButton tab={MainScreenTab.BUILDINGS} />
      <SideMenuButton tab={MainScreenTab.OTHERS_BUILDINGS} />
      <SideMenuButton tab={MainScreenTab.SEARCH} />

      {isExpertUser && <SideMenuButton tab={MainScreenTab.EXPERT_REGISTRATION} />}
    </SideMenu>
  );
};
